module.exports = __webpack_public_path__ + "static/media/login.44cc2888.svg";